import * as React from "react";
import { useContext } from "react";
import PageMenuItem from "../../../../Layout/PageMenu/PageMenuItem";
import { EditProjectContext } from "../../EditProjectContext";
import { ProjectState } from "../../../ViewModel/ProjectState";
import { ReadOnlyProps } from "../../ReadOnlyProps";

type Props = {
  onClick: () => void;
};

export function ClearAllRoutingsButton({ onClick, isReadOnly }: Props & ReadOnlyProps) {
  const { project } = useContext(EditProjectContext);

  const isDisabled = (): boolean => {
    if (project.State !== ProjectState.Sandbox) {
      return true;
    }
    if (!project.ltlPipelines) {
      return true;
    }
    return !project.ltlPipelines.some((p) => (p.routing?.length || 0) > 0);
  };

  return (
    <PageMenuItem
      align="right"
      color="primary"
      type="button"
      onClick={() => onClick()}
      disabled={isDisabled() || isReadOnly}
    >
      Clear All Routings
    </PageMenuItem>
  );
}
